import axios from "axios";
const API = process.env.VUE_APP_API_URL + "/registers";

export default {
  create(user) {
    return axios.post(API, { "user": user });
  }
};